interface NavFunctionArguments {
    goToHomepage: (e: React.MouseEvent) => void;
    goToConfigurator: (e: React.MouseEvent) => void;
    eaccountingEnabled?: boolean;
    themesEnabled?: boolean;
}

interface NavConfigurationItem {
    name: string;
    url?: string;
    icon: string;
    label?: string;
    children?: Array<{
        name: string;
        url: string;
        icon?: string;
        isExternal?: boolean;
        onClick?: (e: React.MouseEvent) => void;
    }>;
}

type NavConfiguration = Array<NavConfigurationItem>;

export default ({
    goToHomepage,
    goToConfigurator,
    themesEnabled = false,
}: NavFunctionArguments): NavConfiguration => {
    const themesNavItems: NavConfiguration = themesEnabled
        ? [
            {
                name: 'routes.bookingWidget',
                url: '/themes',
                icon: '',
                children: [
                    { name: 'routes.themes', url: '/themes' },
                    { name: 'routes.developerTools', url: '/themes/developer' },
                ],
            },
        ]
        : [];
    const nav = [
        {
            name: 'routes.dashboard',
            url: '/dashboard',
            icon: '',
        },
        {
            name: 'routes.calendar',
            url: '/scheduler',
            icon: '',
        },
        {
            name: 'routes.myServices',
            url: '/services',
            icon: '',
            children: [
                {
                    name: 'routes.services',
                    url: '/services',
                },
                {
                    name: 'routes.articles',
                    url: '/articles',
                    icon: ''
                },
                {
                    name: 'routes.promoCodes',
                    url: '/promo-codes-value-cards',
                },
                {
                    name: 'routes.customFields',
                    url: '/custom-fields',
                },
                {
                    name: 'routes.tags',
                    url: '/tags',
                },
            ],
        },
        {
            name: 'routes.resources',
            url: '/resources',
            icon: ''
        },
        {
            name: 'routes.mySchedules',
            url: '/schedules',
            icon: '',
            children: [
                {
                    name: 'routes.schedules',
                    url: '/schedules',
                },
                {
                    name: 'routes.timeExceptions',
                    url: '/time-exceptions',
                },
                {
                    name: 'routes.timeExceptionsReport',
                    url: '/time-exceptions-report',
                },
            ]
        },
        {
            name: 'routes.customers',
            url: '/customers',
            icon: '',
            children: [
                {
                    name: 'routes.allCustomers',
                    url: '/customers',
                },
                {
                    name: 'routes.reviews',
                    url: '/reviews',
                },
                {
                    name: 'routes.newsletter',
                    url: '/newsletters',
                },
                {
                    name: 'routes.mailchimpSettings',
                    url: '/mailchimp-settings',
                },
            ],
        },
        {
            name: 'routes.bookings',
            url: '/bookings',
            icon: '',
        },
        {
            name: 'routes.website',
            icon: '',
            url: '/homepage'
        },
        ...themesNavItems,
        {
            name: 'routes.eaccounting',
            icon: '',
            children: [
                {
                    name: 'routes.eaccounting.settings',
                    url: '/eaccounting/settings',
                },
                {
                    name: 'routes.eaccounting.priceArticleMappings',
                    url: '/eaccounting/articles',
                },
                {
                    name: 'routes.eaccounting.summarizedInvoices',
                    url: '/eaccounting/summarized-invoices',
                }
            ],
        },
        {
            name: 'routes.settings',
            url: '',
            icon: '',
            children: [
                {
                    name: 'routes.company',
                    url: '/company',
                },
                {
                    name: 'routes.bookingSettings',
                    url: '/booking-settings',
                },
                {
                    name: 'routes.bookingPrintout',
                    url: '/booking-printout',
                },
                {
                    name: 'routes.systemSettings',
                    url: '/system-settings',
                },
                {
                    name: 'routes.paymentSettings',
                    url: '/payment-settings',
                },
                {
                    name: 'routes.codelockSettings',
                    url: '/codelock-settings',
                },
                {
                    name: 'routes.webhookSettings',
                    url: '/webhook-settings',
                },
                {
                    name: 'routes.apiKeys',
                    url: '/api-keys',
                },
                {
                    name: 'routes.syncWithExternalCalendar',
                    url: '/sync',
                },
                {
                    name: 'routes.googleMeetSettings',
                    url: '/google-meet-settings',
                },
            ],
        },        
        {
            name: 'routes.support',
            icon: '',
            url: '/support'
        }
    ];

    return nav;
};
